(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-amazon-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-review-carousel')) {
    customElements.define('ks-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
        this.dots = this.querySelector('[data-review-dots]');
        this.page = 0;
        this.userPaused = false;
        this.hoverPaused = false;
        this.focusPaused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;
        this.interval = Number(this.dataset.interval) || 6000;
        this.previousButton = this.querySelector('[data-review-previous]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.pauseButton = this.querySelector('[data-review-pause]');
        if (!this.track || !this.slides.length) return;
        this.previousButton.addEventListener('click', () => this.goTo(this.page - 1));
        this.nextButton.addEventListener('click', () => this.goTo(this.page + 1));
        this.pauseButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
          this.pauseButton.textContent = this.userPaused ? 'Play reviews' : 'Pause reviews';
          this.syncTimer();
        });
        this.addEventListener('pointerenter', () => { this.hoverPaused = true; this.syncTimer(); });
        this.addEventListener('pointerleave', () => { this.hoverPaused = false; this.syncTimer(); });
        this.addEventListener('focusin', () => { this.focusPaused = true; this.syncTimer(); });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.focusPaused = false;
            this.syncTimer();
          }
        });
        this.reducedMotion.addEventListener('change', (event) => {
          this.autoplay = this.dataset.autoplay === 'true' && !event.matches;
          this.syncTimer();
        });
        this.dots.addEventListener('click', (event) => {
          const dot = event.target.closest('[data-review-page]');
          if (dot) this.goTo(Number(dot.dataset.reviewPage));
        });
        this.buildDots();
        this.updateSlides();
        this.resizeObserver = new ResizeObserver(() => this.onResize());
        this.resizeObserver.observe(this);
        this.syncTimer();
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      cardsPerPage() {
        if (window.matchMedia('(max-width: 749px)').matches) return 1;
        if (window.matchMedia('(max-width: 989px)').matches) return 2;
        return 3;
      }

      pageCount() {
        return Math.max(1, Math.ceil(this.slides.length / this.cardsPerPage()));
      }

      onResize() {
        this.page = Math.min(this.page, this.pageCount() - 1);
        this.buildDots();
        this.updateSlides();
      }

      buildDots() {
        this.dots.replaceChildren();
        for (let index = 0; index < this.pageCount(); index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ks-reviews__dot';
          dot.dataset.reviewPage = index;
          dot.setAttribute('aria-label', `Show review page ${index + 1}`);
          this.dots.append(dot);
        }
      }

      goTo(page) {
        const count = this.pageCount();
        this.page = (page + count) % count;
        this.updateSlides();
      }

      updateSlides() {
        if (!this.track) return;
        const firstVisible = this.page * this.cardsPerPage();
        const firstSlide = this.slides[firstVisible];
        const offset = firstSlide ? firstSlide.getBoundingClientRect().left - this.track.getBoundingClientRect().left : 0;
        this.track.style.transform = `translateX(-${offset}px)`;
        this.slides.forEach((slide, index) => {
          const visible = index >= firstVisible && index < firstVisible + this.cardsPerPage();
          slide.setAttribute('aria-hidden', String(!visible));
          slide.inert = !visible;
        });
        this.dots.querySelectorAll('[data-review-page]').forEach((dot, index) => {
          dot.setAttribute('aria-current', String(index === this.page));
        });
      }

      syncTimer() {
        window.clearInterval(this.timer);
        const stopped = this.userPaused || this.hoverPaused || this.focusPaused || !this.autoplay || this.pageCount() < 2;
        if (!stopped) this.timer = window.setInterval(() => this.goTo(this.page + 1), this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ks-customer-reviews')) {
customElements.define('ks-customer-reviews', class extends HTMLElement {
connectedCallback() {
this.abort = new AbortController();
const options = {signal:this.abort.signal};
this.track=this.querySelector('.ks-customer-reviews__track');
this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.pause=this.querySelector('[data-pause]');
this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(window.Shopify?.designMode);
this.update=()=>{const item=this.track.firstElementChild;if(!item)return;const gap=parseFloat(getComputedStyle(this.track).columnGap);this.step=item.getBoundingClientRect().width+gap;this.visible=Math.max(1,Math.round((this.track.clientWidth+gap)/this.step));const first=Math.round(this.track.scrollLeft/this.step);this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;this.querySelector('[data-status]').textContent=`${first+1}–${Math.min(first+this.visible,this.track.children.length)} of ${this.track.children.length}`;};
this.move=(direction,wrap=false)=>{this.update();this.track.scrollTo({left:wrap && this.next.disabled?0:this.track.scrollLeft+direction*this.step*this.visible,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
this.prev.addEventListener('click',()=>this.move(-1),options);this.next.addEventListener('click',()=>this.move(1),options);this.track.addEventListener('scroll',this.update,{...options,passive:true});
this.pause?.addEventListener('click',()=>{this.paused=!this.paused;this.pause.textContent=this.paused?'▶':'Ⅱ';this.pause.setAttribute('aria-label',this.paused?'Resume automatic reviews':'Pause automatic reviews');},options);
if(this.pause && this.paused){this.pause.textContent='▶';this.pause.setAttribute('aria-label','Resume automatic reviews');}
this.addEventListener('mouseenter',()=>this.hovered=true,options);this.addEventListener('mouseleave',()=>this.hovered=false,options);
this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();
if(this.dataset.autoplay==='true')this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!document.hidden&&!this.contains(document.activeElement)&&!this.querySelector('details[open]'))this.move(1,true);},Number(this.dataset.interval)*1000);
}
disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.observer?.disconnect();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-display-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ks-display-gallery')) {
  customElements.define('ks-display-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ks-display-gallery__grid');
      this.previous = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      this.update = () => {
        const items = [...this.track.children];
        if (!items.length) { this.querySelector('.ks-display-gallery__controls').hidden = true; return; }
        const step = items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      };
      this.move = (direction) => {
        const item = this.track.firstElementChild;
        if (!item) return;
        this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.previous.onclick = () => this.move(-1);
      this.next.onclick = () => this.move(1);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
      this.hovered = false;
      this.onEnter = () => { this.hovered = true; };
      this.onLeave = () => { this.hovered = false; };
      this.addEventListener('pointerenter', this.onEnter);
      this.addEventListener('pointerleave', this.onLeave);
      this.visibilityObserver = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; }, { threshold: .25 });
      this.visibilityObserver.observe(this);
      if (this.dataset.autoplay === 'true' && !window.Shopify?.designMode) {
        this.timer = setInterval(() => {
          if (!this.inView || this.hovered || document.hidden || this.contains(document.activeElement) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.update();
          if (this.next.disabled) this.track.scrollTo({ left: 0, behavior: 'smooth' });
          else this.move(1);
        }, Number(this.dataset.interval || 8) * 1000);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); this.visibilityObserver?.disconnect(); this.track?.removeEventListener('scroll', this.update); this.removeEventListener('pointerenter', this.onEnter); this.removeEventListener('pointerleave', this.onLeave); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-retail-detail"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ks-retail-detail'))customElements.define('ks-retail-detail',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const stage=this.querySelector('.ks-retail-detail__stage');const initial=stage.querySelector('img').cloneNode(true);const thumbs=Array.from(this.querySelectorAll('[data-thumb]'));const first=initial.cloneNode(true);first.loading='lazy';first.removeAttribute('fetchpriority');thumbs[0].replaceChildren(first);let index=0;const selectImage=i=>{index=(i+thumbs.length)%thumbs.length;const img=(index===0?initial:thumbs[index].querySelector('img')).cloneNode(true);img.loading='eager';img.removeAttribute('sizes');img.removeAttribute('srcset');stage.replaceChildren(img);thumbs.forEach((t,n)=>t.setAttribute('aria-current',String(n===index)));this.querySelector('[data-image-status]').textContent=(index+1)+' / '+thumbs.length};thumbs.forEach((t,i)=>t.addEventListener('click',()=>selectImage(i)));this.querySelector('[data-image-prev]').addEventListener('click',()=>selectImage(index-1));this.querySelector('[data-image-next]').addEventListener('click',()=>selectImage(index+1));const tabs=Array.from(this.querySelectorAll('[role=tab]'));const panels=Array.from(this.querySelectorAll('[role=tabpanel]'));const activate=i=>{tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(i===n));t.tabIndex=i===n?0:-1;panels[n].hidden=i!==n})};tabs.forEach((t,i)=>{t.addEventListener('click',()=>activate(i));t.addEventListener('keydown',e=>{let next=i;if(e.key==='ArrowRight')next=(i+1)%tabs.length;else if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();activate(next);tabs[next].focus()})});const dialog=this.querySelector('dialog');const opener=this.querySelector('[data-order-open]');opener.addEventListener('click',()=>dialog.showModal());this.querySelector('[data-order-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>opener.focus());dialog.addEventListener('click',e=>{const r=dialog.getBoundingClientRect();if(e.target===dialog&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))dialog.close()});
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-retail-ready-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ks-retail-order'))customElements.define('ks-retail-order',class extends HTMLElement{
 connectedCallback(){if(this.initialized)return;this.initialized=true;const dialog=this.querySelector('dialog');if(!dialog)return;
 this.addEventListener('click',event=>{const trigger=event.target.closest('[data-retail-order]');if(!trigger)return;const card=trigger.closest('article');const title=card.querySelector('h3').textContent.trim();dialog.querySelector('[data-retail-title]').textContent=title;dialog.querySelector('[data-retail-details]').textContent=card.querySelector('.ks-retail-products__details')?.textContent.trim()||'';const photo=dialog.querySelector('.ks-retail-order__photo');photo.replaceChildren();const image=card.querySelector('img');if(image){const copy=image.cloneNode(true);copy.loading='eager';photo.append(copy)}const email=dialog.querySelector('[data-retail-email]');if(email)email.href='mailto:'+email.dataset.email+'?subject='+encodeURIComponent('Retail 2-pack order enquiry: '+title)+'&body='+encodeURIComponent('Hello, I would like to order the retail two-pack: '+title+'. Please share availability and ordering details.');this.trigger=trigger;dialog.showModal()});
 dialog.querySelector('[data-retail-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});dialog.addEventListener('close',()=>this.trigger?.focus());
 }
});

  } catch(e) { console.error(e); }
})();
})();
